import CommentExternalController from './components/desktopApp/comments/CommentExternalController';
import LongRead from './components/desktopApp/longread/page';
import { FormatLinkedText } from './components/export/FormatLinkedText';
import { AllowedActions as LongreadAllowedActions } from './constants/AllowedActions';
export { LongRead, CommentExternalController, FormatLinkedText, LongreadAllowedActions };
export default LongRead;
//# sourceMappingURL=index.js.mapimport CommentExternalController from './components/desktopApp/comments/CommentExternalController';
import LongRead from './components/desktopApp/longread/page';
import { FormatLinkedText } from './components/export/FormatLinkedText';
import { AllowedActions as LongreadAllowedActions } from './constants/AllowedActions';
export { LongRead, CommentExternalController, FormatLinkedText, LongreadAllowedActions };
export default LongRead;
//# sourceMappingURL=index.js.map